import UpdateBlogPost from "./UpdateBlogPost";
import { FiEdit, FiEye } from "react-icons/fi";
import { useEffect, useState } from "react";
import { blogPostServices } from "../../../../APIServices/SitePilotManagement/BlogManagement/blogPostServices";
import Swal from "sweetalert2";
import { Button } from "react-bootstrap";
import BlogPostPreview from "../../../LandingPage/Blog/BlogPostPreview";

const SingleBlogPost = ({ postId, blogCategories, getBlogPostList }) => {
  const [openModules, setOpenModules] = useState("preview");
  const [blogTitle, setBlogTitle] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [subCategoryId, setSubCategoryId] = useState("");
  const [shortDescription, setShortDescription] = useState("");
  const [longDescription, setLongDescription] = useState("");
  const [tags, setTags] = useState([]);
  const [status, setStatus] = useState("draft");
  const [loader, setLoader] = useState(false);

  const updatedBlogPost = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to update this Post?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(true)
        let userData = {}
        userData.postId = postId
        userData.title = blogTitle
        userData.categoryId = categoryId
        userData.subCategoryId = subCategoryId
        userData.status = status
        userData.shortDescription = shortDescription
        userData.longDescription = longDescription
        userData.tags = tags
        let data = await blogPostServices.updatedBlogPost(userData)
        if (data?.statusCode === 200) {
          getBlogPostList()
          getPublicSingleBlogPost()
        }
        setLoader(false)
      }
    });
  };

  const getPublicSingleBlogPost = async () => {
    let data = await blogPostServices.getPublicSingleBlogPost(
      postId,
    );
    setBlogTitle(data?.data?.title || "");
    setCategoryId(data?.data?.categoryId || "");
    setSubCategoryId(data?.data?.subCategoryId || "");
    setShortDescription(data?.data?.shortDescription || "");
    setLongDescription(data?.data?.longDescription || "");
    setTags(data?.data?.tags || []);
    setStatus(data?.data?.status);
  };

  const hasEmptyTag = () => {
    return tags?.some(tag => tag.trim() === "");
  };

  useEffect(() => {
    if (postId) {
      getPublicSingleBlogPost()
    }
  }, [postId]);
  return (
    <>
      <div className="hstack justify-content-between p-2 pe-3">
        <div className="hstack gap-2">
          <Button
            variant={
              openModules === "preview" ? "primary" : "outline-primary"
            }
            size="sm"
            onClick={() => setOpenModules("preview")}
          >
            Preview
          </Button>
          <Button
            variant={
              openModules === "edit" ? "primary" : "outline-primary"
            }
            size="sm"
            onClick={() => setOpenModules("edit")}
          >
            Edit Blog
          </Button>
        </div>
        {openModules === "edit" &&
          <Button
            disabled={
              !blogTitle ||
              !categoryId ||
              !subCategoryId ||
              !status ||
              !shortDescription ||
              !longDescription ||
              loader ||
              hasEmptyTag()
            }
            onClick={updatedBlogPost}
            style={{ fontSize: 12 }}
          >
            <FiEdit /> Update
          </Button>
        }
      </div>
      <div
        className="overflow-auto"
        style={{ height: "calc(100vh - 230px)" }}
      >
        <div className="preview-scroll">
          <div className="preview-block">
            {openModules === "preview" ? (
              <div className="w-75 m-auto">
                <BlogPostPreview
                  postId={postId}
                />
              </div>
            ) : (
              openModules === "edit" && (
                <UpdateBlogPost
                  blogCategories={blogCategories}
                  blogTitle={blogTitle}
                  setBlogTitle={setBlogTitle}
                  categoryId={categoryId}
                  setCategoryId={setCategoryId}
                  subCategoryId={subCategoryId}
                  setSubCategoryId={setSubCategoryId}
                  shortDescription={shortDescription}
                  setShortDescription={setShortDescription}
                  longDescription={longDescription}
                  setLongDescription={setLongDescription}
                  tags={tags}
                  setTags={setTags}
                  status={status}
                  setStatus={setStatus}
                />
              )
            )}
          </div>
        </div>
      </div>
    </>
  )
};

export default SingleBlogPost;
